var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticClass:"hidden-xs-only"},[_c('v-timeline',_vm._l((_vm.entries),function(entry,index){return _c('BigScreenTimelineItem',{key:index,attrs:{"entry":entry}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }